module.exports = __webpack_public_path__ + "static/media/whiteBack3.d17a7d98.svg";